var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "40px",
    viewBox: "0 0 43 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "77C645AD-4B94-4AEC-BF2A-4393DBC3BC92") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-1",
    transform: "translate(-755.000000, -1914.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(222.000000, 1729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(533.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "briefcase-light",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4375,4 L13.4375,8 L29.5625,8 L29.5625,4 C29.5625,3.26666667 28.9578125,2.66666667 28.21875,2.66666667 L14.78125,2.66666667 C14.0421875,2.66666667 13.4375,3.26666667 13.4375,4 Z M10.75,8 L10.75,4 C10.75,1.79166667 12.5556641,0 14.78125,0 L28.21875,0 C30.4443359,0 32.25,1.79166667 32.25,4 L32.25,8 L37.625,8 C40.5896484,8 43,10.3916667 43,13.3333333 L43,34.6666667 C43,37.6083333 40.5896484,40 37.625,40 L5.375,40 C2.41035156,40 0,37.6083333 0,34.6666667 L0,13.3333333 C0,10.3916667 2.41035156,8 5.375,8 L10.75,8 Z M30.90625,10.6666667 L12.09375,10.6666667 L5.375,10.6666667 C3.88847656,10.6666667 2.6875,11.8583333 2.6875,13.3333333 L2.6875,21.3333333 L14.78125,21.3333333 L17.46875,21.3333333 L25.53125,21.3333333 L28.21875,21.3333333 L40.3125,21.3333333 L40.3125,13.3333333 C40.3125,11.8583333 39.1115234,10.6666667 37.625,10.6666667 L30.90625,10.6666667 Z M40.3125,24 L28.21875,24 L28.21875,28 C28.21875,29.475 27.0177734,30.6666667 25.53125,30.6666667 L17.46875,30.6666667 C15.9822266,30.6666667 14.78125,29.475 14.78125,28 L14.78125,24 L2.6875,24 L2.6875,34.6666667 C2.6875,36.1416667 3.88847656,37.3333333 5.375,37.3333333 L37.625,37.3333333 C39.1115234,37.3333333 40.3125,36.1416667 40.3125,34.6666667 L40.3125,24 Z M17.46875,24 L17.46875,28 L25.53125,28 L25.53125,24 L17.46875,24 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseLight);
export default __webpack_public_path__ + "static/media/briefcase-light.df93a12a6243fffd8d1e9c24fa32883e.svg";
export { ForwardRef as ReactComponent };